// Figma "Card" 879:388 (SVARA V2 REDESIGN), from the iOS card-glow handoff. Layers, back to
// front: an orange outer glow, the red fill, a red inner glow added with plus-lighter, and a thin
// gold stroke inside the edge. Pressing scales the card to 0.95 and flares both glows.
// Shared by CardPlate.tsx (native) and CardPlate.web.tsx.
export const FILL = ['#970501', '#220802'] as const;
export const STROKE = ['#FFFF9E', '#FFF908'] as const;
export const GLOW_OUTER = '255, 114, 0';
export const GLOW_INNER = '#FF0000';

/** Figma blur / spread values on the 390 frame; `glowUnit` maps them to screen pixels. */
export const GLOW = {
	rest: { outerBlur: 10, outerSpread: 0, innerBlur: 10, innerSpread: 0 },
	pressed: { outerBlur: 16, outerSpread: 2, innerBlur: 14, innerSpread: 1 },
} as const;

export const PRESS_SCALE = 0.95;
export const PRESS_IN_MS = 80;
export const PRESS_OUT_MS = 200;

export type CardPlateProps = {
	pressed: boolean;
	width: number;
	height: number;
	radius: number;
	strokeWidth: number;
	glowUnit: number;
	outerGlowOpacity: number;
	fill: readonly [string, string];
	animate: boolean;
};

export const outerGlowShadow = ({ pressed, glowUnit, outerGlowOpacity }: CardPlateProps) => {
	const glow = pressed ? GLOW.pressed : GLOW.rest;
	return `0px 0px ${glow.outerBlur * glowUnit}px ${glow.outerSpread * glowUnit}px rgba(${GLOW_OUTER}, ${outerGlowOpacity})`;
};

export const innerGlowShadow = ({ pressed, glowUnit }: CardPlateProps) => {
	const glow = pressed ? GLOW.pressed : GLOW.rest;
	return `inset 0px 0px ${glow.innerBlur * glowUnit}px ${glow.innerSpread * glowUnit}px ${GLOW_INNER}`;
};
